import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { isServerError } from "../../../config/api";
import Format from "../../../helpers/Format";
import ConsultarService, { Status, Inscription, OpcaoParcelamento, Parcelamento } from "../../../services/ConsultarService";
import Show from "../../Show";
import Modal from "../../Modal";
import Alert from "../../Alert";
import Loader from "../../Loader";
import ItemSituacao from "../../ItemSituacao";
import ItemInscricao from "../ItemInscricao";
import ItemSituacaoEmpty from "../../ItemSituacaoEmpty";
import { useHistory } from "react-router-dom";
import { useQuery } from "../../../helpers/Utils";
import Button from "../../Button";
import AgilisServices, { EnableRefisBannerParams, GenerateBilletsPayload, GenerateBilletsResponse } from "../../../services/AgilisServices";
import PaymentModal from "../PaymentModal";
import BilletConfirmationModal from "../BilletConfirmationModal";

import style from "./styles.module.scss";
import { useEffect } from "react";
import moment from "moment";
import { RefisBannerInstallments } from "../../RefisBannerInstallments";

const cn = (...classNames: string[]) => classNames
  .join(" ")
  .split(/\s+/)
  .filter(Boolean)
  .map((className) => style[className] || className)
  .join(" ");

interface Props {
  documento: string;
  title: string;
  status: Status;
  reloadSearch(): void;
  totalBalances?: [] | any;
  totalBalancesRefis?: [] | any;
  enabledRefis?: boolean;
  attendant_id?: number;
  showAddress: boolean;
  consultType: string;
  consultValue: string;
  onPaymentError?(message: string): void;
}

interface Data {
  title: string;
  subtitle: string;
  total: number;
  showed: boolean;
  selectable: boolean;
  data: Inscription[];
}

function groupByAdministrativeInscription(inscriptions: Inscription[]): Inscription[][] {
  const administrativeGroups = new Map<string, Inscription[]>();

  inscriptions.forEach((inscription) => {
    const key = inscription.administrative_inscription || `cda-${inscription.id}`;
    const currentGroup = administrativeGroups.get(key) || [];
    currentGroup.push(inscription);
    administrativeGroups.set(key, currentGroup);
  });

  return Array.from(administrativeGroups.values());
}

function getNegotiableGroupIds(status: Status): string[] {
  const groupIds = new Set<string>();

  Object.keys(status).forEach((statusKey) => {
    status[statusKey].data.forEach(({ group_payment, balance }) => {
      if (group_payment && balance !== 0) {
        groupIds.add(group_payment);
      }
    });
  });

  return Array.from(groupIds);
}

const ENABLED_REFIS_RULE_ID: number[] = [109, 110, 111];
const keyI18n = "translations.consultDebts.receiptTypeItem";

export default function ItemTipoReceitaV2({ documento, attendant_id, title, status, reloadSearch, totalBalances, totalBalancesRefis, enabledRefis, showAddress, consultType, consultValue, onPaymentError}: React.PropsWithChildren<Props>) {
  const { t } = useTranslation();
  const history = useHistory();

  const query = useQuery();
  const digital = Boolean(query.get("digital"));
  const digitalQuery = digital ? "&digital=true" : "";


  const [show, setShow] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [pendingPayment, setPendingPayment] = useState<{ ids: number[]; pix: boolean }>();
  const [confirmationError, setConfirmationError] = useState("");
  const [showModalSimulacao, setShowModalSimulacao] = useState(false);
  const [showModalRestriction, setShowModalRestriction] = useState(false);
  const [showConfirmarParcelamento, setShowConfirmarParcelamento] = useState(false);
  const [showParcelamento, setShowParcelamento] = useState(false);
  const [showButtonEfetuarParcelamento, setShowButtonEfetuarParcelamento] = useState(false);
  const [showButtonCancelarParcelamento, setShowButtonCancelarParcelamento] = useState(false);
  const [showConfirmarCancelarParcelamento, setShowConfirmarCancelarParcelamento] = useState(false);

  const [errorSimulacao, setErrorSimulacao] = useState("");
  const [errorEfetuarParcelamento, setErrorEfetuarParcelamento] = useState("");
  const [errorCancelarParcelamento, setErrorCancelarParcelamento] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingPix, setLoadingPix] = useState(false);
  const [loadingSimulacao, setLoadingSimulacao] = useState(false);
  const [loadingEfetuarParcelamento, setLoadingEfetuarParcelamento] = useState(false);
  const [loadingCancelarParcelamento, setLoadingCancelarParcelamento] = useState(false);
  const isProcessingBillet = loading || loadingPix;

  const [parcelamento, setParcelamento] = useState<Parcelamento>();
  const [opcoesParcelamento, setOpcoesParcelamento] = useState<OpcaoParcelamento[]>([]);
  const [opcaoSelecionada, setOpcaoSelecionada] = useState<OpcaoParcelamento>();

  const [payment, setPayment] = useState<GenerateBilletsResponse>();
  const [inscricoesSelecionadas, setInscricoesSelecionadas] = useState<number[]>([]);
  const [inscricoesComRestricao, setInscricoesComRestricao] = useState<Inscription[]>([]);
  const [refisHabilitado, setRefisHabilitado] = useState(false);
  const [receiptType, setReceiptType]: any = useState(0)

  const [totalSelected, setTotalSelected] = useState(0);
  const [group, setGroup] = useState<string[]>([]);
  const situacoes = Object.keys(status);
  const visibleSituacoes = situacoes.filter((situacao) => (
    situacao !== "Quitado" || status[situacao].total_inscriptions > 0
  ));

  const [expandedGroupIds, setExpandedGroupIds] = useState<string[]>(() => (
    getNegotiableGroupIds(status)
  ));
  const [extinctCda, setExtintiCda] = useState(false);
  const [extinctCdasLoaded, setExtinctCdasLoaded] = useState(false);
  const [loadingExtinctCdas, setLoadingExtinctCdas] = useState(false);
  const [errorExtinctCdas, setErrorExtinctCdas] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selecteds, setSelecteds] = useState(0)
  const [allSelected, setAllSelected] = useState(false);
  const [selectedValue, setSelectedValue] = useState(0);
  const [selectedRefisValue, setSelectedRefisValue] = useState(0);

  const [showInformations, setShowInformations] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [contributorEmail, setContributorEmail] = useState('');
  const [email, setEmail] = useState('');
  const [validEmail, setValidEmail] = useState(false);
  const [errorAdd, setErrorAdd] = useState(false);
  const [refisEnabled, setRefisEnabled] = useState(false);
  const [refisBannerEnabled, setRefisBannerEnabled] = useState(false);

  const isGroupExpanded = (groupPayment: string) => expandedGroupIds.includes(groupPayment);

  useEffect(() => {
    setExpandedGroupIds(getNegotiableGroupIds(status));
  }, [status]);

  useEffect(() => {
    InscriptionsBehavior();
  });

  useEffect(() => {
    const fetchRefisBanner = async () => {
      try {
        const firstStatusKey = Object.keys(status)[0];
        const inscriptionsList = firstStatusKey ? status[firstStatusKey]?.data ?? [] : [];

        if (!inscriptionsList.length) {
          return;
        }

        const params: EnableRefisBannerParams = {
          inscriptions_ids: inscriptionsList.map((inscription) => inscription.id),
        };

        const firstInscription = inscriptionsList[0] as any;

        if (firstInscription?.receipt_type_id != null) {
          params.receipt_type_id = firstInscription.receipt_type_id;
        }

        if (firstInscription?.contributor_id != null) {
          params.contributor_id = firstInscription.contributor_id;
        }

        if (documento) {
          params.contributor_document = documento;
        }

        const response = await AgilisServices.enableRefisBanner(params);

        const enabled = typeof response === "boolean"
          ? response
          : Boolean(
              (response as any)?.enabled ??
              (response as any)?.enable_banner ??
              (response as any)?.refis_enabled ??
              (response as any)?.data ??
              response
            );

        setRefisBannerEnabled(enabled);
      } catch (error) {
        setRefisBannerEnabled(false);
      }
    };

    fetchRefisBanner();
  }, []);

  const [datas, setDatas] = useState<Data[]>(visibleSituacoes.map((situacao, index): Data => {
    if (index === 0) {
      return {
        title: situacao,
        subtitle: Format.currency(status[situacao].total_balance),
        total: status[situacao].total_inscriptions,
        showed: true,
        selectable: true,
        data: status[situacao].data,
      };
    }

    if (situacao === "Quitado") {
      return {
        title: situacao,
        subtitle: "",
        total: status[situacao].total_inscriptions,
        showed: false,
        selectable: false,
        data: status[situacao].data,
      };
    }

    return {
      title: situacao,
      subtitle: "",
      total: status[situacao].total_inscriptions,
      showed: false,
      selectable: false,
      data: status[situacao].data,
    };
  }));

  function resetSelection() {
    datas.map((data) => {
      data.data = data.data.map((inscription) => {
        inscription.selected = false;

        return inscription;
      });

      return data;
    });
  }

  const handleHideModalRestriction = () => setShowModalRestriction(false);

  const handleHideBoleto = () => {
    setShowModal(false);
    setPayment(undefined);
  };

  const handleHideParcelamento = () => {
    setShowParcelamento(false);
    setParcelamento(undefined);
    reloadSearch();
  };

  const handleToggleShow = () => {
    setShow(!show);
  };

  const unselectAll = () => {
    setDatas(datas.map((data) => {
      data.data = data.data.map((inscription) => {
        inscription.selected = false;

        return inscription;
      });

      return data;
    }));
  };

  const selectInscription = (inscricaoSelected: Inscription) => {
    const { id, group_payment, payment_request_code, refis_enabled, receipt_type_id } = inscricaoSelected;

    setDatas(datas.map((data, index) => {
      if (index === 0) {
        if (payment_request_code) {
          data.data = data.data.map((inscription) => {
            if (inscription.id === id && inscription.payment_request_code === payment_request_code) {
              inscription.selected = true;
            }

            return inscription;
          });
        } else {
          data.data = data.data.map((inscription) => {
            if (inscription.id === id) {
              inscription.selected = true;
            }

            return inscription;
          });
        }
      }

      return data;
    }))
    setRefisHabilitado(refis_enabled);
    setReceiptType(receipt_type_id)
    checkShowButtons();
    setGroup([group_payment]);
  };

  const toggleSelectInscription = (inscricaoSelected: Inscription) => {
    setDatas(datas.map((data) => {
      data.data = data.data.map((inscription) => {
        if (inscription.id === inscricaoSelected.id) {
          inscription.selected = !inscription.selected;
        }

        return inscription;
      });

      return data;
    }));

    checkShowButtons();
  };

  const checkShowButtons = () => {
    if (datas[0]) {
      const inscriptions = datas[0].data;
      const inscriptionsSelecteds = inscriptions.filter((inscription) => inscription.selected);
      const inscriptionWithPaymentRequest = inscriptionsSelecteds.find((inscription) => inscription.payment_request_code !== null);

      if (inscriptionWithPaymentRequest && inscriptionWithPaymentRequest.payment_request_code !== null) {
        if (inscriptionWithPaymentRequest.refis_enabled) {
          const paymentRequestCode = inscriptionWithPaymentRequest.payment_request_code;
          const inscriptionsWithPaymentRequest = inscriptions.filter((inscription) => inscription.payment_request_code === paymentRequestCode);

          setShowButtonCancelarParcelamento(inscriptionsSelecteds.length === inscriptionsWithPaymentRequest.length);
          setShowButtonEfetuarParcelamento(false);
        } else {
          setShowButtonCancelarParcelamento(false);
          setShowButtonEfetuarParcelamento(false);
        }

      } else {
        setShowButtonEfetuarParcelamento(inscriptionsSelecteds.length > 0);
        setShowButtonCancelarParcelamento(false);
      }

    }
  };

  const handleSelect = (inscricaoSelected: Inscription) => () => {
    if (inscricaoSelected.group_payment) {
      if (group.includes(inscricaoSelected.group_payment)) {
        toggleSelectInscription(inscricaoSelected);
      } else {
        if (group.length) {
          unselectAll();
        }

        selectInscription(inscricaoSelected);
      }
    }

    if (datas[0]) {
      const inscriptionsSelecteds = datas[0].data.filter((i) => i.selected);
      setInscricoesSelecionadas(inscriptionsSelecteds.map((i) => i.id));
      setTotalSelected(inscriptionsSelecteds.reduce((t, i) => t + i.balance, 0));
      if (inscriptionsSelecteds.length === 0) {
        setGroup([]);
        setRefisHabilitado(false);
      }
    }
  };

  const handleSelectGroup = (
    groupPayment: string,
    inscriptions: Inscription[],
  ) => (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();

    const shouldSelect = event.currentTarget.checked;
    const groupIds = new Set(inscriptions.map(({ id }) => id));
    const selectedInscriptions = shouldSelect ? inscriptions : [];

    setDatas((currentDatas) => currentDatas.map((currentData) => ({
      ...currentData,
      data: currentData.data.map((inscription) => ({
        ...inscription,
        selected: shouldSelect
          ? groupIds.has(inscription.id)
          : groupIds.has(inscription.id)
            ? false
            : inscription.selected,
      })),
    })));

    setInscricoesSelecionadas(selectedInscriptions.map(({ id }) => id));
    setTotalSelected(selectedInscriptions.reduce((total, inscription) => total + inscription.balance, 0));
    setSelectedValue(selectedInscriptions.reduce((total, inscription) => total + inscription.balance, 0));
    setSelectedRefisValue(selectedInscriptions.reduce((total, inscription) => total + inscription.balance_to_legal_action, 0));
    setSelecteds(selectedInscriptions.length);
    setIsChecked(shouldSelect);
    setAllSelected(shouldSelect);
    setGroup(shouldSelect ? [groupPayment] : []);
    setRefisHabilitado(shouldSelect && Boolean(inscriptions[0]?.refis_enabled));

    if (shouldSelect && inscriptions[0]) {
      setReceiptType(inscriptions[0].receipt_type_id);
    }
  };

  const handleSelectAdministrativeInscription = (
    inscriptions: Inscription[],
    shouldSelect: boolean,
  ) => {
    const inscriptionIds = new Set(inscriptions.map(({ id }) => id));
    const paymentGroup = inscriptions[0]?.group_payment;
    const canPreserveCurrentSelection = !shouldSelect || group.length === 0 || group.includes(paymentGroup);
    const nextDatas = datas.map((currentData) => ({
      ...currentData,
      data: currentData.data.map((inscription) => ({
        ...inscription,
        selected: inscriptionIds.has(inscription.id)
          ? shouldSelect
          : shouldSelect && !canPreserveCurrentSelection
            ? false
            : inscription.selected,
      })),
    }));
    const selectedInscriptions = nextDatas.flatMap(({ data }) => data).filter(({ selected }) => selected);

    setDatas(nextDatas);
    setInscricoesSelecionadas(selectedInscriptions.map(({ id }) => id));
    setTotalSelected(selectedInscriptions.reduce((total, inscription) => total + inscription.balance, 0));
    setSelectedValue(selectedInscriptions.reduce((total, inscription) => total + inscription.balance, 0));
    setSelectedRefisValue(selectedInscriptions.reduce((total, inscription) => total + inscription.balance_to_legal_action, 0));
    setSelecteds(selectedInscriptions.length);
    setGroup(selectedInscriptions.length > 0 && paymentGroup ? [paymentGroup] : []);
    setRefisHabilitado(selectedInscriptions.some(({ refis_enabled }) => refis_enabled));

    if (selectedInscriptions[0]) {
      setReceiptType(selectedInscriptions[0].receipt_type_id);
    }
  };

  const createBilletPayload = useCallback((selectedIds: number[]): GenerateBilletsPayload => {
    const selectedInscriptions = datas[0]?.data.filter((item) => selectedIds.includes(item.id)) || [];
    const firstSelected = selectedInscriptions[0] as any;

    const payload: GenerateBilletsPayload = {
      contributor_id: firstSelected?.contributor_id ?? "",
      receipt_type_id: firstSelected?.receipt_type_id ?? 0,
      inscriptions_ids: selectedIds,
    };

    if (contributorEmail) {
      payload.email = contributorEmail;
    }

    return payload;
  }, [contributorEmail, datas]);

  const requestBillet = useCallback((selectedIds: number[]) => {
    const payload = createBilletPayload(selectedIds);
    return AgilisServices.generateBillets(payload);
  }, [createBilletPayload]);

  const handleBilletError = (err: unknown, fallbackMessage = t(`${keyI18n}.errors.connection`)) => {
    const message = isServerError(err) ? err.error || fallbackMessage : fallbackMessage;
    setConfirmationError(message);
    onPaymentError?.(message);
  };

  const generatePayment = async (selectedIds: number[], pix: boolean, confirmed = false) => {
    if (!selectedIds.length) return;
    const setBusy = pix ? setLoadingPix : setLoading;
    setBusy(true);
    setConfirmationError("");
    onPaymentError?.("");
    try {
      if (!confirmed && await AgilisServices.previousBillets({ inscriptions_ids: selectedIds })) {
        setPendingPayment({ ids: [...selectedIds], pix });
        setShowModalSimulacao(false);
        setShowModal(false);
        return;
      }
      const response = await requestBillet(selectedIds);
      setPendingPayment(undefined);
      setShowModal(true);
      setShowModalSimulacao(false);
      setTotalSelected(0);
      setInscricoesSelecionadas([]);
      resetSelection();
      setGroup([]);
      setPayment(response);
    } catch (err) {
      handleBilletError(err, t(`${keyI18n}.errors.generatePayment`));
    } finally {
      setBusy(false);
    }
  };

  const handleSubmit = (inscriptions = inscricoesSelecionadas) => generatePayment(inscriptions, false);
  const handlePixPayment = (inscriptions = inscricoesSelecionadas) => generatePayment(inscriptions, true);

  const closeConfirmation = () => {
    if (isProcessingBillet) return;
    setPendingPayment(undefined);
    setConfirmationError("");
  };

  const handleConfirmarParcelamento = () => {
    setShowConfirmarParcelamento(true);
    setErrorSimulacao("");
    setErrorEfetuarParcelamento("");
  };

  const handleDesistirParcelamento = () => {
    setShowModalSimulacao(false);
    setShowConfirmarParcelamento(false);
    setOpcaoSelecionada(undefined);
    setOpcoesParcelamento([]);
    setShowInformations(false);
    setValidEmail(false);
    setAcceptTerms(false);
  };

  const handleEfetuarParcelamento = async () => {
    setLoadingEfetuarParcelamento(true);
    setErrorSimulacao("");
    setErrorEfetuarParcelamento("");
    try {
      if (opcaoSelecionada) {
        await ConsultarService
          .gerarParcelamento(inscricoesSelecionadas, opcaoSelecionada.num_installments, opcaoSelecionada.refis_rule_id, attendant_id, documento)
          .then((response) => {
            setParcelamento(response);
            handleDesistirParcelamento();
            setShowParcelamento(true);
            sendInstallmentEmail(response);
          }).catch((err) => {
            if (isServerError(err)) {
              setErrorEfetuarParcelamento(err.error);
            } else {
              console.error(err);
            }
          }).finally(() => {
            setLoadingEfetuarParcelamento(false);
          });
      } else {
        setErrorEfetuarParcelamento(t(`${keyI18n}.errors.selectInstallment`));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSimulacao = async (inscriptions?: number[], installments?: OpcaoParcelamento) => {
    setShowModalRestriction(false);
    setLoadingSimulacao(true);
    setShowModalSimulacao(true);
    setParcelamento(undefined);
    setErrorEfetuarParcelamento("");
    setErrorSimulacao("");
    try {
      await ConsultarService
        .simulacaoParcelamento(inscriptions || inscricoesSelecionadas)
        .then((response) => {
          setOpcoesParcelamento(response);
          if (installments) {
            setOpcaoSelecionada(installments);
            setShowInformations(true);
          };
        }).catch((err) => {
          if (isServerError(err)) {
            setErrorSimulacao(err.error);
          } else {
            console.error(err);
          }
        }).finally(() => {
          setLoadingSimulacao(false);
        });
    } catch (err) {
      setLoadingSimulacao(false);
      console.error(err);
    }
  };

  const handleToConsultarParcelamentos = () => {
    setShowModal(false);
    setShowModalSimulacao(false);
    setShowConfirmarParcelamento(false);
    setShowParcelamento(false);
    setTimeout(() => history.push(`/consultar/parcelamentos?d=${documento}&n=${parcelamento?.code}${digitalQuery}`), 500);
  };

  const handleShowConfirmarCancelarParcelamento = () => {
    setShowConfirmarCancelarParcelamento(true);
  };

  const handleHideConfirmarCancelarParcelamento = () => {
    setShowConfirmarCancelarParcelamento(false);
  };

  const handleConfirmarCancelarParcelamento = async () => {
    const numeroParcelamento = datas[0].data.find((inscricao) => inscricoesSelecionadas.includes(inscricao.id))?.payment_request_code;
    if (numeroParcelamento) {
      setLoadingCancelarParcelamento(true);
      try {
        await ConsultarService
          .cancelarParcelamento(inscricoesSelecionadas, numeroParcelamento)
          .then((response) => {
            setDatas(datas.map((data) => {
              data.data = data.data.map((inscription) => {
                if (inscricoesSelecionadas.includes(inscription.id)) {
                  const inscriptionResponse = response.inscriptions.find((i) => i.id === inscription.id);

                  if (inscriptionResponse) {
                    return inscriptionResponse;
                  }
                }

                return inscription;
              });

              return data;
            }));
            checkShowButtons();
            handleHideConfirmarCancelarParcelamento();
          }).catch((err) => {
            if (isServerError(err)) {
              setErrorCancelarParcelamento(err.error);
            } else {
              console.error(err);
            }
          }).finally(() => {
            setLoadingCancelarParcelamento(false);
          });
      } catch (err) {
        setLoadingCancelarParcelamento(false);
        console.error(err);
      }
    }
  };

  const handleToConsultNegotiation = (inscription_id: number) => {
    datas.forEach((data) => {
      data.data.forEach((inscription) => {
        if (inscription_id ===inscription.id) {
          setTimeout(() => window.open(`/consultar/parcelamentos?d=${documento}&n=${inscription.payment_request_code}`, "_blank"), 500);
        }
      })
    });
  };

  const handleVerificaInscricoesComRestricoes = useCallback(() => {
    const inscricoesComRestricaoEncontrada: Inscription[] = [];

    datas.forEach((data) => {
      data.data.forEach((inscription) => {
        if (inscricoesSelecionadas.includes(inscription.id) && inscription.refis_enabled && inscription.has_restriction) {
          inscricoesComRestricaoEncontrada.push(inscription);
        }
      })
    });
      handleSimulacao();
  }, [inscricoesSelecionadas]);

  const toggleVisibleCdas = (groupId: string) => {
    setExpandedGroupIds((currentGroups) => (
      currentGroups.includes(groupId)
        ? currentGroups.filter((currentGroupId) => currentGroupId !== groupId)
        : [...currentGroups, groupId]
    ));
  };

  const setVisibleCdas = toggleVisibleCdas;
  const setVisibleCdasNegotiation = toggleVisibleCdas;

  const loadExtinctCdas = async () => {
    if (extinctCdasLoaded || loadingExtinctCdas) {
      return;
    }

    setLoadingExtinctCdas(true);
    setErrorExtinctCdas("");

    try {
      const response = await ConsultarService.debitosExtintos(documento, consultType, consultValue);
      const extinctStatus = response.data && response.data[title] && response.data[title]["Quitado"];

      setDatas(datas.map((data) => {
        if (data.title === "Quitado") {
          return {
            ...data,
            total: extinctStatus?.total_inscriptions || 0,
            data: extinctStatus ? extinctStatus.data : [],
          };
        }

        return data;
      }));
      setExtinctCdasLoaded(true);
    } catch (err) {
      if (isServerError(err)) {
        if (err.error === "Débitos não encontrados para os dados informados." || err.error === "Não existem débitos para o CPF/CNPJ informado.") {
          setDatas(datas.map((data) => data.title === "Quitado" ? { ...data, total: 0, data: [] } : data));
          setExtinctCdasLoaded(true);
        } else {
          setErrorExtinctCdas(err.error);
        }
      } else {
        setErrorExtinctCdas(t(`${keyI18n}.errors.extinctConnection`));
        console.error(err);
      }
    } finally {
      setLoadingExtinctCdas(false);
    }
  };

  const setVisibleExtinctCdas = (element: any) => {
    const extinctGroupment = document.getElementById(element);
    const extinticChild = extinctGroupment?.firstElementChild

    extinctGroupment?.classList.add(style.extinticGroupBodySelected);
    extinticChild?.classList.add(style.extinctGroupmentSelected);

    if(extinctCda == false) {
      setExtintiCda(true);
      loadExtinctCdas();
    }else {
      setExtintiCda(false);
      extinctGroupment?.classList.remove(style.extinticGroupBodySelected);
      extinticChild?.classList.remove(style.extinctGroupmentSelected);
    }
  }

  const showCount = () => {
    const listElements = document.querySelectorAll("#checkboxInscription");
    var groupmentValue = 0;
    Array.from(listElements).map((checkBox) => {
      const inscriptionValue = parseFloat(checkBox.getAttribute("data-value") as string);
      groupmentValue = (groupmentValue + inscriptionValue);
    })
    const groupValueElement = document.getElementById(groupmentValue.toFixed(2).toString());
    const getFirstChild = groupValueElement?.firstElementChild as HTMLElement;
    const getSecoundElementChild = groupValueElement?.children[1] as HTMLElement;
    const getSecoundChild = groupValueElement?.children[2];
    const getThirdChild = groupValueElement?.lastElementChild;
    getFirstChild.classList.add(style.dynamicGroupHide);
    getSecoundElementChild.classList.add(style.dynamicGroupHide);
    getSecoundChild?.classList.remove(style.dynamicGroupHide);
    getThirdChild?.classList.remove(style.dynamicGroupHide);
  }

  const selectInscriptions = () => {
    const inputElement = document.querySelectorAll("#checkboxInscription");
    Array.from(inputElement).map((eachone) => {
      const element = eachone as HTMLElement;
      const inscriptionId = parseInt(element.getAttribute("data-id") as string);
      datas.map((data) => {
        data.data.map((inscription) => {
          if(inscription.id == inscriptionId) {
            handleSelect(inscription);
          };
        });
      });
    });
  };

  const InscriptionsBehavior = () => {
    const inputElement = document.querySelectorAll("#checkboxInscription");
    const clearButton = document.getElementById("clearButton");
    const selectionInformations = document.getElementById("inscriptionsQuantity");
    const elementButton = document.getElementById("selectAll");
    const installmentBtn = document.getElementById("installmentBtn");
    const ticketBtn = document.getElementById("ticketBtn");
    var arrayElements: Array<Element> = [];
    Array.from(inputElement).map((eachone) => {
      arrayElements.push(eachone);
      const element = eachone as HTMLElement;
      const refisEnabled =  element.getAttribute("data-refisenabled") as unknown as boolean;
      const inscriptionValue = refisEnabled ?
                                  parseFloat(element.getAttribute("data-refisvalue") as string)
                                : parseFloat(element.getAttribute("data-value") as string);
      const inscriptionRefisValue = refisEnabled ?
                                  parseFloat(element.getAttribute("data-value") as string)
                                : parseFloat(element.getAttribute("data-refisvalue") as string);
      element.onchange = function() {
        setSelectedValue(selectedValue + inscriptionValue);
        setSelectedRefisValue(selectedRefisValue + inscriptionRefisValue)
        if(element.hasAttribute("checked")){
          showCount();
          clearButton?.classList.add(style.clearAllSelections);
          setSelecteds(selecteds + 1);
          selectionInformations?.classList.remove(style.insciptionSelectedsInvisible);
          selectionInformations?.classList.add(style.insciptionSelecteds);
          installmentBtn?.classList.add(style.installmentButton);
          ticketBtn?.classList.add(style.ticketButton);
          installmentBtn?.classList.remove(style.installmentButtonDisabled);
          ticketBtn?.classList.remove(style.ticketButtonDisabled);
          selectInscriptions();

        }else {
          setSelecteds(selecteds - 1);
          setAllSelected(false);
          setIsChecked(false);
          elementButton?.classList.remove(style.selectAllButtonMarked);
          selectionInformations?.classList.remove(style.insciptionSelectedsInvisible);
          selectionInformations?.classList.add(style.insciptionSelecteds);
          setSelectedValue(selectedValue - inscriptionValue);
          setSelectedRefisValue(selectedRefisValue - inscriptionRefisValue)
          selectInscriptions();
        };
        if (!(arrayElements.find(element => element.hasAttribute("checked")))) {
          clearSelections();
          setSelecteds(0);
          setSelectedValue(0);
          setSelectedRefisValue(0)
          installmentBtn?.classList.remove(style.installmentButton);
          ticketBtn?.classList.remove(style.ticketButton);
          installmentBtn?.classList.add(style.installmentButtonDisabled);
          ticketBtn?.classList.add(style.ticketButtonDisabled);
        };
        const elementsCheked = arrayElements.filter(item => (item as HTMLInputElement).checked);
        if(elementsCheked.length == arrayElements.length){
          setIsChecked(true);
          setAllSelected(true);
          elementButton?.classList.add(style.selectAllButtonMarked);
          selectionInformations?.classList.add(style.insciptionSelectedsInvisible);
          selectionInformations?.classList.remove(style.insciptionSelecteds);
        };
      };
    });
  };

  const MarkAllInscriptions = (selected : boolean, groupPayment : string, refisEnabled: boolean) => {
    if (datas[0]) {
      datas[0].data.map((items) => {
        if(items.group_payment === groupPayment) {
          items.selected = selected;
          setGroup([groupPayment]);
          setRefisHabilitado(refisEnabled);
          checkShowButtons();
        }
      })
      const inscriptionsSelecteds = datas[0].data.filter((i) => i.selected);
      setInscricoesSelecionadas(inscriptionsSelecteds.map((i) => i.id));
      setTotalSelected(inscriptionsSelecteds.reduce((t, i) => t + i.balance, 0));
      if (inscriptionsSelecteds.length === 0) {
        setGroup([]);
        setRefisHabilitado(false);
      }
    }
  }

  const selectAllInscriptions = (element : any) => {
    const elementButton = document.getElementById(element);
    const listElements = document.querySelectorAll("#checkboxInscription");
    const Elements = listElements[0] as HTMLElement;
    const grouPayment = Elements.getAttribute("data-grouppayment") as string;
    const refisEnabled = (Elements.getAttribute("data-refisEnabled") == 'false' ? false : true);
    const selectionInformations = document.getElementById("inscriptionsQuantity");
    const installmentBtn = document.getElementById("installmentBtn");
    const ticketBtn = document.getElementById("ticketBtn");
    if(isChecked) {
      setIsChecked(false);
      setSelecteds(0);
      clearSelections();
      setAllSelected(false);

      elementButton?.classList.remove(style.selectAllButtonMarked);
      const clearButton = document.getElementById("clearButton");
      clearButton?.classList.remove(style.clearAllSelections);
      selectionInformations?.classList.add(style.insciptionSelectedsInvisible);
      selectionInformations?.classList.remove(style.insciptionSelecteds);
      installmentBtn?.classList.remove(style.installmentButton);
      ticketBtn?.classList.remove(style.ticketButton);
      installmentBtn?.classList.add(style.installmentButtonDisabled);
      ticketBtn?.classList.add(style.ticketButtonDisabled);
      Array.from(listElements).map((box) => {
        box.removeAttribute("checked");
        const boxElement = box as HTMLInputElement;
        boxElement.checked = false;
      })
      MarkAllInscriptions(false, grouPayment, refisEnabled);
    }else {
      setIsChecked(true);
      setAllSelected(true);
      setSelectedValue(0);
      setSelectedRefisValue(0)
      setSelecteds(listElements.length);

      showCount();
      MarkAllInscriptions(true, grouPayment, refisEnabled);

      const clearButton = document.getElementById("clearButton");
      elementButton?.classList.add(style.selectAllButtonMarked);
      clearButton?.classList.add(style.clearAllSelections);
      installmentBtn?.classList.add(style.installmentButton);
      ticketBtn?.classList.add(style.ticketButton);
      installmentBtn?.classList.remove(style.installmentButtonDisabled);
      ticketBtn?.classList.remove(style.ticketButtonDisabled);
      var totalValue = 0
      var totalRefisValue = 0
      Array.from(listElements).map((box) => {
        const refisEnabled = box.getAttribute("data-refisenabled") as unknown as boolean;
        totalValue = refisEnabled ?
                                totalValue + parseFloat(box.getAttribute("data-refisvalue") as string)
                              : totalValue + parseFloat(box.getAttribute("data-value") as string);
        totalRefisValue = refisEnabled ?
                                totalRefisValue + parseFloat(box.getAttribute("data-value") as string)
                              : totalRefisValue + parseFloat(box.getAttribute("data-refisvalue") as string);
        box.setAttribute("checked", "true");
        const boxElement = box as HTMLInputElement;
        boxElement.checked = true;
      })
      setSelectedValue(totalValue);
      setSelectedRefisValue(totalRefisValue);
      selectionInformations?.classList.add(style.insciptionSelectedsInvisible);
      selectionInformations?.classList.remove(style.insciptionSelecteds);
    }
  }

  const clearSelections = () => {
    setIsChecked(false);
    setAllSelected(false);
    setSelecteds(0);
    setSelectedValue(0);
    setSelectedRefisValue(0);
    const selectionInformations = document.getElementById("inscriptionsQuantity");
    const removeAll = document.getElementById("selectAll");
    const clearButton = document.getElementById("clearButton");
    const elementsUnmark = document.querySelectorAll("#checkboxInscription");
    const installmentBtn = document.getElementById("installmentBtn");
    const ticketBtn = document.getElementById("ticketBtn");
    removeAll?.classList.remove(style.selectAllButtonMarked);
    clearButton?.classList.remove(style.clearAllSelections);
    Array.from(elementsUnmark).map((box) => {
      box.removeAttribute("checked");
      const boxElement = box as HTMLInputElement;
      boxElement.checked = false;
    })

    hideReset();

    selectionInformations?.classList.add(style.insciptionSelectedsInvisible);
    selectionInformations?.classList.remove(style.insciptionSelecteds);
    installmentBtn?.classList.remove(style.installmentButton);
    ticketBtn?.classList.remove(style.ticketButton);
    installmentBtn?.classList.add(style.installmentButtonDisabled);
    ticketBtn?.classList.add(style.ticketButtonDisabled);
  }

  const hideReset = () => {
    const listElements = document.querySelectorAll("#checkboxInscription");
    var groupmentValue = 0

    Array.from(listElements).map((checkBox) => {
      const inscriptionValue = parseFloat(checkBox.getAttribute("data-value") as string);
      groupmentValue = (groupmentValue + inscriptionValue);
    })

    const groupValueElement = document.getElementById(groupmentValue.toFixed(2).toString());
    if(groupValueElement != null || groupValueElement == 0){
      const getFirstChild = groupValueElement?.firstElementChild as HTMLElement;
      const getSecoundElementChild = groupValueElement?.children[1] as HTMLElement;
      const getSecoundChild = groupValueElement?.children[2];
      const getThirdChild = groupValueElement?.lastElementChild;
      getFirstChild.classList.remove(style.dynamicGroupHide);
      getSecoundElementChild.classList.remove(style.dynamicGroupHide)
      getSecoundChild?.classList.add(style.dynamicGroupHide);
      getThirdChild?.classList.add(style.dynamicGroupHide);
    }

    if (datas[0]) {
      datas[0].data.map((items) => {
        items.selected = false;
      })
      const inscriptionsSelecteds = datas[0].data.filter((i) => i.selected);
      setInscricoesSelecionadas(inscriptionsSelecteds.map((i) => i.id));
      setTotalSelected(inscriptionsSelecteds.reduce((t, i) => t + i.balance, 0));
      if (inscriptionsSelecteds.length === 0) {
        setGroup([]);
        setRefisHabilitado(false);
      };
    };
  };

  const groupmentTitle = (oppenedInsciptions: number, isAgreement: boolean) => {
    if (isAgreement) {
      return <span className={cn("opennedNegotiation")}>{t(`${keyI18n}.groups.openNegotiation`, {
        count: oppenedInsciptions,
        inscriptions: t(`${keyI18n}.count.${oppenedInsciptions > 1 ? "inscriptionsCapitalized" : "inscriptionCapitalized"}`),
      })}</span>
    } else {
      return <span>{t(`${keyI18n}.groups.openInscriptions`, {
        count: oppenedInsciptions,
        inscriptions: t(`${keyI18n}.count.${oppenedInsciptions > 1 ? "inscriptionsCapitalized" : "inscriptionCapitalized"}`),
      })}</span>
    }
  }

  const groupmentsString = (groupment: string) => {
    if (groupment == null) {
      return 'sent_protest';
    } else {
      return groupment;
    }
  }

  const handleSelecionarOpcao = (opcao: OpcaoParcelamento) => () => {
    setOpcaoSelecionada(opcao);
    setShowInformations(true);
  };

  const termsAccepted = () => { !acceptTerms ? setAcceptTerms(true) : setAcceptTerms(false) };

  const validateEmail = (value = email) => {
    const normalizedEmail = value.trim();
    const validationemail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(normalizedEmail);
    const inputField = (document.getElementById('emailrequired')as HTMLInputElement | null);
    if(normalizedEmail.length === 0){
      inputField?.classList.remove('errorfield');
      setValidEmail(false);
    }else if(validationemail) {
      inputField?.classList.remove('errorfield');
      setValidEmail(true);
      setErrorAdd(false);
    }else {
      inputField?.classList.add('errorfield');
      setValidEmail(false);
      setErrorAdd(true);
    }
  };

  const updateAndValidate = (e: string) => {
    const normalizedEmail = e.trim();
    setEmail(e);
    setContributorEmail(normalizedEmail);
    validateEmail(e);
  };

  const submitAttendance = async () => {
    const contributor_document = documento
    const contributor_attendance_histories = {'attendance_place':'Portal do Contribuinte - Consultar Dívidas',
                                              'attendant':'Assitente Virtual',
                                              'attendance_subject':'term_accepted'};
    const attendanceData = {contributor_document, contributor_attendance_histories};

    await ConsultarService
      .attendanceRegistration(attendanceData)
  };

  const aceptAndContinue = () => {
    handleConfirmarParcelamento()
    submitAttendance();
  };

  const sendInstallmentEmail = async (response: any) => {
    const contributor_document = documento
    const installment_code = response.code;
    const emailData = contributorEmail
    const installmentData = {contributor_document: contributor_document, installment_code: installment_code, emailData: emailData}
    await ConsultarService
      .sendEmailConfirmation(installmentData)
  }

  const returRefisValue = () => (
    totalBalances.map((balancewithoutRefis: any) => (
      balancewithoutRefis.type == title &&
      <div className={cn("totalTributeBalanceRefis")}>
        <strong>{t(`${keyI18n}.labels.totalTributeWith`)} </strong>
        <strong className={cn("refisLabel pgm-label-large")}>{t(`${keyI18n}.labels.refis`)}</strong>
        <strong>: </strong>
        <span className={cn("balanceValue")}>{Format.currency(balancewithoutRefis.balance)}</span>
      </div>
    ))
  );

  const returnTributeValuesRefisEnabled = () => {
    return (
      totalBalancesRefis.map((balanceInfo: any) => {
        if(balanceInfo.type == title) {
          return(
            <div className={cn("totalTributeBalance")}>
              <strong>{t(`${keyI18n}.labels.totalTribute`)} </strong>
              {Format.currency(balanceInfo.balance)}
              {returRefisValue()}
            </div>
          )
        }
      })
    )
  };

  const returnTributeValues = () => {
    return (
      totalBalances.map((balanceInfo: any) => {
        if(balanceInfo.type == title) {
          return(
            <div className={cn("totalTributeBalance")}>
              <strong>{t(`${keyI18n}.labels.totalTribute`)} </strong>
              {Format.currency(balanceInfo.balance)}
            </div>
          )
        }
      })
    )
  }

  const handleBannerClick = (installments: OpcaoParcelamento, inscriptions: number[]) => {
    if (installments.num_installments === 1) handleSubmit(inscriptions);
    else {
      handleSimulacao(inscriptions, installments);
    };
  }

  const selectedAgreementInscription = datas[0]?.data.find((inscription) => (
    inscricoesSelecionadas.includes(inscription.id) && inscription.payment_request_code !== null
  ));

  return (
    <div className={cn("itenContent")} data-refis-banner-enabled={refisBannerEnabled}>
      <div className={cn("detailedInformations")}>
        <Show if={show}>
          <Modal title={t(`${keyI18n}.restriction.title`)} show={showModalRestriction} onHide={handleHideModalRestriction}>
            <div className={cn("simulacao-parcelamento text-center pgm-body-medium")}>
              <p className={cn("text-center")}>
                {t(`${keyI18n}.restriction.description`)}
              </p>
              <ul className={cn("list-unstyled")}>
                {inscricoesComRestricao.map((inscricao) => (
                  <li key={inscricao.id}>{t(`${keyI18n}.labels.cda`)} {inscricao.cda}</li>
                ))}
              </ul>
              <p className={cn("text-center")}>
                {t(`${keyI18n}.restriction.consequence`)}<br/>
                {t(`${keyI18n}.actions.continueQuestion`)}
              </p>
              <Button variant="outlined" size="small" type="button" className={cn("modalActionButton")} onClick={handleHideModalRestriction}>{t(`${keyI18n}.actions.no`)}</Button>
              <Button variant="filled" size="small" type="button" onClick={() => handleSimulacao()}>{t(`${keyI18n}.actions.yes`)}</Button>
            </div>
          </Modal>
          <Modal title={t(`${keyI18n}.cancellation.title`)} show={showConfirmarCancelarParcelamento} onHide={handleHideConfirmarCancelarParcelamento}>
            <div className={cn("simulacao-parcelamento text-center pgm-body-medium")}>
              {errorCancelarParcelamento && <Alert>{errorCancelarParcelamento}</Alert>}
              <p className={cn("text-center")}>{t(`${keyI18n}.cancellation.description`)}</p>
              <Button variant="outlined" size="small" type="button" className={cn("modalActionButton")} disabled={loadingCancelarParcelamento} onClick={handleHideConfirmarCancelarParcelamento}>{t(`${keyI18n}.actions.no`)}</Button>
              <Button variant="filled" size="small" type="button" disabled={loadingCancelarParcelamento} onClick={handleConfirmarCancelarParcelamento}>{t(`${keyI18n}.actions.yes`)}</Button>
            </div>
          </Modal>
          <BilletConfirmationModal
            open={Boolean(pendingPayment)}
            loading={isProcessingBillet}
            inCash
            hasPreviousBillet
            error={confirmationError}
            onClose={closeConfirmation}
            onConfirm={() => { if (pendingPayment) generatePayment(pendingPayment.ids, pendingPayment.pix, true); }}
          />
          <PaymentModal
            open={showModal}
            payment={payment}
            onClose={handleHideBoleto}
          />
          <Modal title={t(`${keyI18n}.installment.title`)} show={showParcelamento} onHide={handleHideParcelamento}>
            {parcelamento && (
              <div className={cn("modal-parcelamento")}>
                <p>{t(`${keyI18n}.installment.success`)}</p>
                <p>{t(`${keyI18n}.installment.instructions`)}</p>
                <p><strong>{t(`${keyI18n}.installment.number`)} {parcelamento.code}</strong></p>
                <Button variant="outlined" size="small" type="button" onClick={handleToConsultarParcelamentos}>
                  {t(`${keyI18n}.actions.consultInstallment`)}
                </Button>
              </div>
            )}
          </Modal>
          <Modal title={showConfirmarParcelamento ? "" : t(`${keyI18n}.simulation.title`)} show={showModalSimulacao} onHide={handleDesistirParcelamento}>
            <Show if={!showConfirmarParcelamento}>
              <div className={cn("simulacao-parcelamento pgm-body-medium")}>
                {errorSimulacao && <Alert>{errorSimulacao}</Alert>}
                {(refisHabilitado) && receiptType === 171 && (
                  <>
                    <p>{t(`${keyI18n}.simulation.refisDescription`)}</p>
                    <p>{t(`${keyI18n}.simulation.refisRules`)}</p>
                  </>
                )}
                <p className={cn("instrucoes-parcelamento")}>{t(`${keyI18n}.simulation.selectOption`)}</p>
                <div className={cn("parcelas")}>
                  {loadingSimulacao && <Loader label={t(`${keyI18n}.simulation.loadingInstallments`)} />}
                  {opcoesParcelamento.map((opcao) => (
                    <Button
                      variant="text"
                      shape="square"
                      size="small"
                      type="button"
                      key={opcao.num_installments}
                      title={t(`${keyI18n}.simulation.${opcaoSelecionada?.num_installments === opcao.num_installments ? "unselectOption" : "chooseOption"}`)}
                      className={cn("installmentOption", opcaoSelecionada?.num_installments === opcao.num_installments ? "selected" : "")}
                      onClick={handleSelecionarOpcao(opcao)}
                    >
                      <span className={cn("quantidade")}>{opcao.num_installments}x</span>
                      <span className={cn("descricao")}>{opcao.simulation}</span>
                      {opcao.discount_percent &&
                        <div>
                          <span className={cn("desconto")}>{t(`${keyI18n}.simulation.discount`, { percent: opcao.discount_percent })}</span>
                          <span className={cn("valueWithoutDiscount pgm-body-small")}>
                            ({opcao.value_saved})
                          </span>
                        </div>
                      }
                    </Button>
                  ))}
                  {!loadingSimulacao && opcoesParcelamento.length === 0 && (
                    <div className={cn("alert alert-warning")}>
                      {t(`${keyI18n}.simulation.minimumInstallmentWarning`)}
                    </div>
                  )}
                </div>
                <Show if={showInformations}>
                  <div>
                    <div className={cn("warning")}>
                      <FontAwesomeIcon icon={faExclamationCircle} />
                      <span className="pgm-label-large">{t(`${keyI18n}.simulation.readTerms`)}</span>
                    </div>
                    <div className={cn("termsTittle")}>
                      <h6 className="pgm-title-small">{t(`${keyI18n}.simulation.legalAct`)}</h6>
                      <h6 className="pgm-title-small">{t(`${keyI18n}.simulation.legalActDate`)}</h6>
                    </div>
                    <div className={cn("termContent")}>
                      <span className={cn("termTheme pgm-body-large")}><strong>{t(`${keyI18n}.simulation.themeLabel`)}</strong> {t(`${keyI18n}.simulation.theme`)}</span>
                      <span className={cn("terTextContent")}>
                        <p className="pgm-body-large">{t(`${keyI18n}.simulation.terms`)}</p>
                      </span>
                    </div>
                    <div className={cn("acceptBox pgm-body-small")}>
                      <input type="checkbox" onClick={termsAccepted}></input>
                      <span>{t(`${keyI18n}.simulation.agree`)}</span>
                    </div>
                  </div>
                </Show>
                <p className={cn("infos")}>
                  {t(`${keyI18n}.simulation.disclaimer`)}
                </p>
                <div className={cn("inputEmail")}>
                  <Show if={showInformations}>
                    <span>{t(`${keyI18n}.simulation.emailLabel`)}</span>
                    <input
                      id="emailrequired"
                      type="text"
                      placeholder={t(`${keyI18n}.simulation.emailPlaceholder`)}
                      className={cn("emailForCodeInput")}
                      onChange={(e) => updateAndValidate(e.target.value)}
                      onBlur={(e) => setContributorEmail(e.target.value.trim())}
                      autoComplete="off"
                    />
                  </Show>
                </div>
                <div className={cn("actions")}>
                  {!loadingSimulacao && opcoesParcelamento.length === 0 && (
                    <>
                      <Button
                        variant="outlined"
                        size="small"
                        type="button"
                        disabled={loading}
                        onClick={handleDesistirParcelamento}
                      >
                        {t(`${keyI18n}.actions.close`)}
                      </Button>
                      <Button
                        variant="filled"
                        size="small"
                        type="button"
                        disabled={loading}
                        onClick={() => handleSubmit()}
                      >
                        {!loading && t(`${keyI18n}.actions.generateCashBillet`)}
                        {loading && t(`${keyI18n}.actions.generatingCashBillet`)}
                      </Button>
                    </>
                  )}
                  {!loadingSimulacao && opcoesParcelamento.length > 0 && (
                    <Button
                      variant="filled"
                      size="small"
                      type="button"
                      disabled={!(acceptTerms && validEmail)}
                      onClick={aceptAndContinue}
                    >
                      {t(`${keyI18n}.actions.makeInstallment`)}
                    </Button>
                  )}
                </div>
              </div>
            </Show>
            <Show if={showConfirmarParcelamento}>
              <div className={cn("simulacao-parcelamento pgm-body-medium")}>
                {errorEfetuarParcelamento && <Alert>{errorEfetuarParcelamento}</Alert>}
                <h2 className="pgm-title-large">{t(`${keyI18n}.confirmation.title`)}</h2>
                <ul>
                  <li>{t(`${keyI18n}.confirmation.items.activation`)}</li>
                  <li>{t(`${keyI18n}.confirmation.items.activationDeadline`)}</li>
                  <li>{t(`${keyI18n}.confirmation.items.unpaidInstallments`)}</li>
                  <li>{t(`${keyI18n}.confirmation.items.dueDate`)}</li>
                  <li>{t(`${keyI18n}.confirmation.items.reduction`)}</li>
                </ul>.
                <h2 className="pgm-title-large">{t(`${keyI18n}.confirmation.refisTitle`)}</h2>
                <ul>
                  <li>{t(`${keyI18n}.confirmation.items.refisCancellation`)}</li>
                  <ul>
                    <li>{t(`${keyI18n}.confirmation.items.refisConsecutive`)}</li>
                    <li>{t(`${keyI18n}.confirmation.items.refisPeriod`)}</li>
                  </ul>
                  <li>{t(`${keyI18n}.confirmation.items.refisBalance`)}</li>
                </ul>
                <div className={cn("actions")}>
                  <Button
                    variant="outlined"
                    size="small"
                    type="button"
                    disabled={loadingEfetuarParcelamento}
                    onClick={handleDesistirParcelamento}
                  >
                    {t(`${keyI18n}.actions.giveUp`)}
                  </Button>
                  <Button
                    variant="filled"
                    size="small"
                    type="button"
                    disabled={loadingEfetuarParcelamento}
                    onClick={handleEfetuarParcelamento}
                  >
                    {t(`${keyI18n}.actions.confirmInstallment`)}
                  </Button>
                </div>
              </div>
            </Show>
          </Modal>
        </Show>
        {inscricoesSelecionadas.length > 0 && (
          <div className={cn("v2PaymentActions")}>
            <Button
              variant="tonal"
              size="extra-small"
              icon={<span className="material-symbols-sharp">qr_code_2</span>}
              disabled={loading || loadingPix || loadingSimulacao}
              onClick={() => handlePixPayment()}
              type="button"
            >
              {t(`${keyI18n}.actions.${loadingPix ? "generatingPayment" : "payPix"}`)}
            </Button>
            <Button
              variant="tonal"
              size="extra-small"
              icon={<span className="material-symbols-sharp">barcode</span>}
              disabled={loading || loadingPix}
              onClick={() => handleSubmit()}
              type="button"
            >
              {t(`${keyI18n}.actions.${loading ? "generatingBillet" : "generateBillet"}`)}
            </Button>
            <Button
              variant="outlined"
              size="extra-small"
              icon={<span className="material-symbols-sharp">attach_money</span>}
              disabled={isProcessingBillet || loadingSimulacao}
              onClick={selectedAgreementInscription
                ? () => handleToConsultNegotiation(selectedAgreementInscription.id)
                : handleVerificaInscricoesComRestricoes}
              type="button"
            >
              {t(`${keyI18n}.actions.${loadingSimulacao
                ? "loadingOptions"
                : selectedAgreementInscription
                  ? "consultInstallment"
                  : "simulateInstallment"}`)}
            </Button>
          </div>
        )}
        <div className={cn("contentInformation")}>
            {datas.map((data, index) => {
              var groupId: Array<string> = []
              var groupnumber = 1;
              var groupnumberNegotiations = 1
              var oppenedInsciptions = 0;
              var groupValue = 0;
              var groupValueLegalAction = 0;
              var balanceToLegalAction = 0;
              var isrefisEnabled : boolean;
              var inscriptionTitle;
              var dynamicId = 0;
              let totalTributeValue: number = 0;
              var requestedAt: string;
              var paymentCode: string | null;

              if (data.title === "A inscrever") {
                if (data.data.length === 0) {
                  return null;
                }
                return (
                  <ItemSituacao
                    key={data.title}
                    title={data.title}
                    subtitle={data.subtitle}
                    showed={data.showed}
                  >
                    <ItemSituacaoEmpty>{t(`${keyI18n}.empty.toRegister`)}</ItemSituacaoEmpty>
                  </ItemSituacao>
                );
              }
            {data.title !== "Quitado" && data.data.map((inscriptionGroup) => (
              !(groupId.includes(inscriptionGroup.group_payment)) && groupId.push(inscriptionGroup.group_payment)
            ))}
            return (
              <div>
                {index === 0 &&
                  (<p className={cn("initialInformation")}>
                    <span>
                      {data.data.some(inscricao =>
                          inscricao.refis_enabled === true &&
                          ((inscricao.refis_rule_id !== undefined && ENABLED_REFIS_RULE_ID.includes(inscricao.refis_rule_id)) ||
                          inscricao.payment_request_code === null)
                        ) ?
                          returnTributeValuesRefisEnabled()
                        : returnTributeValues()
                      }
                    </span>
                  </p>)}
                {data.title === "Quitado" && (
                  <div className={cn("extinticGroupBody")} id="extinticGroup">
                    <div className={cn("extinctGroupment")}>
                      <Button
                        variant="text"
                        iconButton
                        size="extra-small"
                        type="button"
                        className={cn("groupToggleButton")}
                        aria-label={t(`${keyI18n}.aria.${extinctCda ? "closeExtinctGroup" : "openExtinctGroup"}`)}
                        aria-expanded={extinctCda}
                        onClick={() => setVisibleExtinctCdas("extinticGroup")}
                        icon={(
                          <span className="material-symbols-sharp" aria-hidden="true">
                            {extinctCda ? "arrow_drop_down" : "arrow_right"}
                          </span>
                        )}
                      />
                      <div className={cn("groupmentInformations")}>
                        <strong>{t(`${keyI18n}.groups.extinct`)}</strong>
                        <span>{t(`${keyI18n}.groups.cdaCount`, { count: data.total })}</span>
                        <span className={cn("negotiationUnavailableTag")}>
                          {t(`${keyI18n}.groups.negotiationUnavailable`)}
                        </span>
                      </div>
                    </div>
                    <div>
                      <Show if={extinctCda}>
                        <div className={cn("extinctGroupmentDebt")}>
                          {loadingExtinctCdas && <Loader label={t(`${keyI18n}.loading.extinctInscriptions`)} />}
                          {errorExtinctCdas && <Alert>{errorExtinctCdas}</Alert>}
                          {!loadingExtinctCdas && extinctCdasLoaded && data.data.length === 0 && (
                            <ItemSituacaoEmpty>{t(`${keyI18n}.empty.extinct`)}</ItemSituacaoEmpty>
                          )}
                          {groupByAdministrativeInscription(data.data).map((administrativeInscriptions) => (
                            <ItemInscricao
                              key={administrativeInscriptions[0].administrative_inscription || administrativeInscriptions[0].id}
                              inscriptions={administrativeInscriptions}
                              attendantCounter={showAddress}
                              onSelect={(inscription) => handleSelect(inscription)()}
                              onSelectAll={handleSelectAdministrativeInscription}
                            />
                          ))}
                        </div>
                      </Show>
                    </div>
                  </div>
                )}
                {groupId.map((groupments) => {
                  let withStateRestriction = false;
                  let withJudicialProcess = false;
                  let penalty = false;
                  if (groupments != null || (groupments == null && data.showed == true)){
                    oppenedInsciptions = 0;
                    groupValue = 0;
                    groupValueLegalAction = 0;
                    var isAgreement = false;
                    var inscriptionId: number;
                    data.data.map((inscricao) => {
                      if (inscricao.group_payment == groupments && inscricao.payment_request_code != null ) {
                        isAgreement = true;
                        inscriptionId = inscricao.id;
                      }
                      if (inscricao.group_payment == groupments && inscricao.with_state_restriction == true) {
                        withStateRestriction = true;
                      }
                      if (inscricao.group_payment == groupments && inscricao.judicial_process_number && !inscricao.penalty) {
                        withJudicialProcess = true;
                      }
                      if(inscricao.group_payment == groupments && inscricao.penalty){
                        penalty = true
                      }
                    })

                    const groupKey = groupmentsString(groupments);
                    const groupInscriptions = data.data.filter((inscricao) => inscricao.group_payment == groupments);

                    isrefisEnabled = false;
                    groupInscriptions.forEach((inscricao) => {
                      oppenedInsciptions++;
                      groupValue += inscricao.balance;
                      groupValueLegalAction += inscricao.balance_to_legal_action;
                      isrefisEnabled = isrefisEnabled || (
                        inscricao.refis_enabled &&
                        ((inscricao.refis_rule_id !== undefined && ENABLED_REFIS_RULE_ID.includes(inscricao.refis_rule_id)) ||
                          inscricao.payment_request_code === null)
                      );
                      requestedAt = inscricao.requested_at;
                      paymentCode = inscricao.payment_request_code;
                    });

                    const negotiableGroupInscriptions = groupInscriptions.filter(({ group_payment, balance }) => (
                      Boolean(group_payment) && balance !== 0
                    ));
                    const isGroupNegotiable = negotiableGroupInscriptions.length > 0;
                    const allNegotiableGroupInscriptionsSelected = isGroupNegotiable &&
                      negotiableGroupInscriptions.every(({ selected }) => Boolean(selected));

                    return (
                      <div className={cn("groupBody")} id={groupKey}>
                        <div className={cn(isAgreement ? "negotiationGroupment" : "groupments")}>
                          <Button
                            variant="text"
                            iconButton
                            size="extra-small"
                            type="button"
                            className={cn("groupToggleButton")}
                            aria-label={t(`${keyI18n}.aria.${isGroupExpanded(groupKey) ? "closeGroup" : "openGroup"}`)}
                            aria-expanded={isGroupExpanded(groupKey)}
                            onClick={() => isAgreement ? setVisibleCdasNegotiation(groupKey) : setVisibleCdas(groupKey)}
                            icon={(
                              <span className="material-symbols-sharp" aria-hidden="true">
                                {isGroupExpanded(groupKey) ? "arrow_drop_down" : "arrow_right"}
                              </span>
                            )}
                          />
                          <div className={cn("groupmentInformations")}>
                            <strong>
                              {isAgreement
                                ? t(`${keyI18n}.groups.negotiation`, { number: groupnumberNegotiations ++ })
                                : penalty
                                  ? t(`${keyI18n}.groups.penalty`)
                                  : withStateRestriction
                                    ? t(`${keyI18n}.groups.restricted`)
                                    : withJudicialProcess
                                      ? t(`${keyI18n}.groups.legalAction`)
                                      : t(`${keyI18n}.groups.administrative`) }
                              <span className={cn("requestedDate")}>{isAgreement && t(`${keyI18n}.groups.negotiationDate`, { date: moment(requestedAt).format('DD/MM/YYYY [às] HH:mm') })}</span>
                            </strong>
                            <span>{t(`${keyI18n}.groups.cdaCount`, { count: oppenedInsciptions })}</span>
                            {!isGroupNegotiable && (
                              <span className={cn("negotiationUnavailableTag")}>
                                {t(`${keyI18n}.groups.negotiationUnavailable`)}
                              </span>
                            )}
                          </div>
                          <div className={cn(isrefisEnabled ? "groumpentValuesWithRefis" : "groumpentValues")} id={(groupValue).toFixed(2).toString()}>
                            <div className={cn("groupGeneralValue")}>
                              <strong>{t(`${keyI18n}.labels.subtotal`)} </strong>
                              <span className={cn("monetaryValue")}>{Format.currency(groupValueLegalAction)}</span>
                            </div>
                            <div className={cn("groupmentValuesWithREFIS")}>
                              <Show if={isrefisEnabled}>
                                <div id="refisValueInfo">
                                  <strong>{t(`${keyI18n}.labels.subtotalWith`)} </strong>
                                  <div className={cn("ifRefisEnabled pgm-label-medium")}>
                                    {t(`${keyI18n}.labels.refis`)}
                                  </div>
                                  :
                                  <strong className={cn("balanceToLegalAction")}>
                                    {Format.currency(groupValue)}
                                  </strong>
                                </div>
                              </Show>
                            </div>
                            <div className={cn("dynamicGroupHide")} id="dynamicGroupInfo">
                              <strong>{t(`${keyI18n}.labels.selectedTotal`)} </strong>
                              <span className={cn("totalSelected")}>{Format.currency(selectedValue)}</span>
                            </div>
                            <div className={cn("dynamicGroupHide")} id="dynamicGroupInfoREFIS">
                              <Show if={isrefisEnabled}>
                                <div id="refisValueInfo">
                                  <strong>{t(`${keyI18n}.labels.selectedTotalWith`)}</strong>
                                  <div className={cn("ifRefisEnabled pgm-label-medium")}>
                                    {t(`${keyI18n}.labels.refis`)}
                                  </div>
                                  <strong>: </strong>
                                  <span className={cn("totalSelected")}>{Format.currency(selectedRefisValue)}</span>
                                </div>
                              </Show>
                            </div>
                          </div>
                          <input
                            className={cn("groupSelectionCheckbox")}
                            type="checkbox"
                            aria-label={t(`${keyI18n}.aria.selectAllGroup`)}
                            checked={allNegotiableGroupInscriptionsSelected}
                            disabled={!isGroupNegotiable}
                            onChange={handleSelectGroup(groupKey, negotiableGroupInscriptions)}
                          />
                        </div>
                        <Show if={isGroupExpanded(groupKey)}>
                          <div className={cn("groupmentDebt")}>
                            <Show if={isrefisEnabled && refisBannerEnabled}>
                              <RefisBannerInstallments
                                inscriptions={data.data}
                                onClick={(installments: OpcaoParcelamento, inscriptions: number[]) => handleBannerClick(installments, inscriptions)}
                              />
                            </Show>
                            {groupByAdministrativeInscription(groupInscriptions).map((administrativeInscriptions) => (
                              <div
                                className={cn("itemInscription")}
                                key={administrativeInscriptions[0].administrative_inscription || administrativeInscriptions[0].id}
                              >
                                <ItemInscricao
                                  inscriptions={administrativeInscriptions}
                                  attendantCounter={showAddress}
                                  individualActionsDisabled={isProcessingBillet}
                                  onSelect={(inscription) => handleSelect(inscription)()}
                                  onSelectAll={handleSelectAdministrativeInscription}
                                  onPix={(inscription) => handlePixPayment([inscription.id])}
                                  onBillet={(inscription) => handleSubmit([inscription.id])}
                                />
                              </div>
                            ))}
                          </div>
                        </Show>
                      </div>
                    )
                  }
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
